var _g, _path, _polygon, _polygon2, _polygon3, _path2, _rect, _path3, _path4, _circle, _ellipse, _path5, _polygon4, _polygon5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _polyline, _path15, _path16, _path17, _line, _polygon6, _polygon7, _ellipse2, _path18, _path19, _rect2, _g2, _ellipse3, _line2, _line3, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g3, _path31, _line4, _line5, _line6, _polyline2, _path32, _text, _line7, _path33, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtpImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M744.07,351.1h0c-25.67,0-46.49,20.81-46.49,46.49v42.48h92.97v-42.48c0-25.67-20.81-46.49-46.49-46.49Zm31.26,78.55h-61.71v-31.66c0-17.04,13.82-30.86,30.86-30.86h0c17.04,0,30.86,13.82,30.86,30.86v31.66Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.77,
    y: 418.82,
    width: 113.81,
    height: 93.77,
    rx: 6.92,
    ry: 6.92,
    fill: "#4ade80",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.85,469.31c2.85-2.57,4.65-6.27,4.65-10.41,0-7.75-6.28-14.03-14.03-14.03s-14.03,6.28-14.03,14.03c0,3.46,1.26,6.63,3.34,9.07l-2,13.99c-.29,2,1.26,3.78,3.28,3.78h17.84c2.07,0,3.64-1.88,3.26-3.92l-2.32-12.52Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M467.24,317.8c-34.22-12.91-58.57-45.96-58.57-84.71,0-45.94,34.23-83.89,78.58-89.72",
    fill: "none",
    stroke: "#002346",
    strokeDasharray: "0 0 11 9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "506.17 122.1 473.11 531.65 683.4 535.92 718.17 123.1 506.17 122.1",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "513.17 130.1 479.17 522.1 676.17 528.1 710.17 131.1 513.17 130.1",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "718.17 123.1 736.67 125.6 702.67 535.6 683.4 535.92 718.17 123.1",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M508.73,427.76l152.74-1.22c8.96-.08,16.38-7,17.07-15.93l13.51-175.11c.46-5.97-4-11.18-9.97-11.65-.25-.02-.5-.03-.75-.03l-156.85-1.23c-5.66-.05-10.4,4.27-10.88,9.91l-15.76,183.51c-.5,5.97,3.93,11.21,9.89,11.71,.33,.03,.67,.04,1,.04Z",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 510.6,
    y: 398.89,
    width: 157.56,
    height: 11.72,
    rx: 5.86,
    ry: 5.86,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M679.88,293.44l-8.14,83.19c-.45,4.64-4.34,8.18-9,8.18h-142.55c-4.9,0-8.88-3.97-8.88-8.88,0-.29,.01-.58,.04-.86l7.88-81.63,78.16-50.77c4.39-2.85,10.09-2.68,14.3,.43l68.19,50.34Z",
    fill: "#bce1ca",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M589.66,269.86h-47.08c-4.74,0-8.59-3.85-8.58-8.6,0-.32,.02-.64,.05-.96l4.94-43.1c.54-4.7,4.51-8.24,9.24-8.24h115.47c5.14,0,9.3,4.16,9.3,9.3,0,.28-.01,.57-.04,.85l-4.12,43c-.42,4.4-4.12,7.77-8.54,7.77h-55.46c-.86,0-1.67,.45-2.11,1.19l-6,9.91c-.28,.48-.89,.64-1.37,.36-.22-.13-.38-.33-.45-.58l-2.92-9.17c-.32-1.02-1.26-1.72-2.33-1.73Z",
    fill: "#4ade80",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 671.06,
    cy: 166.21,
    r: 18.86,
    fill: "#bce1ca",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 671.11,
    cy: 161.14,
    rx: 7.77,
    ry: 7.43,
    fill: "#4ade80",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M660.4,181.77s.68-7.56,5.85-10.53c2.68-1.56,6.02-1.38,8.52,.46,2.15,1.63,4.37,4.89,4.64,11.42,0-.01-9.95,4.99-19.01-1.35Z",
    fill: "#4ade80",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "691.79 91.22 723.67 97.43 698.42 98.67 705.45 112.5 731.81 98.95 687.79 80.87 691.79 91.22",
    fill: "#4ade80",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "691.79 91.22 687.79 101.43 699.82 101.43 698.42 98.67 723.67 97.43 691.79 91.22",
    fill: "#4ade80",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M503.69,447.56s28.58-8.54,39.3,5.36c0,0,23.83,34.94,31.77,62.74,0,0,18.42,62.44-60.58,63.44l-10.49-131.54Z",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M460.78,460.59s55.14-25.14,67.43-6.86l7.43,15.15c-7.62-1.6-15.37-2.57-23.15-2.91l-57.14-3.09,5.43-2.29Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M477.97,579.11h36s46.21-7.01,40.21-50.01c.04-.04-5.48,41.83-76.21,50.01Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M535.64,468.88s8.85,3.29,12.35,20.51l5.69,25.09s14.34,53-75.71,64.59h-183s54.83-11.2,35.58-66.78l-15.72-35,124.63-14.27,15.93-.17s66.25,2.31,80.25,6.03Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M481.39,527.22c-3.66,3.56-9.13,4.48-13.75,2.31l-19.32-14.56c-2.93-2.77-4.09-6.94-3-10.83h0l-4.9-6.53,8.71-8.16,3.21,3.15c3.48,5.18,7.74,9.78,12.63,13.66l.09,.07c5.93,4.82,12.31,9.06,19.05,12.65,4.76,2.93-2.72,8.24-2.72,8.24Z",
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M490.85,521.61c9,5.2,3.83,9.09,3.83,9.09l-6.81,5.91s0,0,0,0c-8.16,5.86-21.21-2.77-22.83-3.89-.04-.03-.09,.02-.07,.07l3.42,6.44s0,.06-.02,.07l-2.92,1.46s-.05,0-.06-.01l-17.66-21.34s0,0,0,0c-9.26-9.47-4.11-14.18-2.81-15.13,.1-.07,.22,.02,.19,.14-1.76,7.79,4.08,11.68,4.08,11.68l17.44,12.4s0,0,0,0c6.55,3.6,10.9,2.15,14.55-1.4,0,0,7.76-5.01,3-8l6.67,2.51Z",
    fill: "#4ade80",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M168.17,367.1l236.31-1.95s12.15-1.67,13.58,6.23l23.71,96.76-138,9.56-97.8-19.58-37.8-91.02Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M260.76,351.04l27.36-6.78,6.81,6.78,9,76.37s5.18,13.41,5.21,13.95-17.54,3.51-17.57,3-11.79-18.17-11.79-18.17l-13.59-49.93-5.43-25.22Z",
    fill: "#fff",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M407.92,365.45s22.29-1.14,26.86,11.14l26,84-5.43,2.29-15.93,.17-22.35-91.22s-.88-6.58-9.15-6.38Z",
    fill: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M256.58,308.34v30.47s15.09,28.28,25.1,30.19c.88,.15,1.78-.05,2.51-.57,2.51-1.74,7.82-7.53,3.94-24.17l-9.45-5.61,.17-7.82s-16.66,2.13-22.27-22.49Z",
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M256.57,338.81l-13.48,6.02c-5.25,2.34-9.72,6.11-12.91,10.89-1.39,2.07-3.03,4.62-4.92,7.72,0,0-33.4,53.57-14.42,63.18,0,0,10.38,9.01,42.34-2.52l3.39,16.01s22.13-6.54,35-8.17c0,0-.72-28.59-8.41-43.49,0,0-14.75-30.77-17-34.13l-9.59-15.51Z",
    fill: "#4ade80",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "294.93 348.1 302.58 369.05 298.75 373.52 302.58 378.8 298.87 392.74",
    fill: "none",
    stroke: "#ed1c24",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M311.17,426.1l-11.11,1.36s-6-74.45-11.93-83.15c0,0,5.76,.25,11.62,1.82,5.54,1.48,10.27,5.07,13.26,9.96s7.84,13.97,13.16,28.02l-4.31,29-1.5,10.14h-.58c-1.51,0-5.65-.88-7.42-9.24-.91-4.39,.8-11.91-2.2-11.91l1,24Z",
    fill: "#4ade80",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M258.67,408.6c.8,.23,2.89,1.1,5.34,1.26,1.73,.11,3.45-.36,4.94-1.25l11.14-6.6c1.46-.87,3.14-1.31,4.84-1.27l20.48,.49c1.7,.04,2.3,2.36,.78,3.14-.97,.5-2.64,.8-5.44,.62-.13,0-.22,.15-.12,.24,.98,.86,3.99,3.59,5.11,5.6,.53,.95-.45,2.04-1.44,1.6-1.29-.58-3.39-1.98-6.14-5.32,1.3,1.5,3.75,5.74,4.43,7.6,.22,.89-.32,1.8-1.21,2.03-.3,.08-.61,.07-.91-.03-1.35-.5-3.28-2.24-5.57-7.27,0,0,2.48,7.11-.44,7.36,0,0-1.2,.27-2.28-3.2-.63-2.02-3.12-2.85-4.78-1.54-.45,.35-.93,.79-1.43,1.34,0,0-12.63,11.28-18.24,7.22-.89-.64-2.04-.79-3.11-.55l-5.73,1.31-.23-12.77Z",
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M256.57,440.11s.86,42,28.59,43c4.08,.09,8.13-.73,11.86-2.39l74.34-32.16c.56-.19,1.26,.32,1.68,1,.85,1.32,2.73,3,7.17,1.55,.54-.16,1.12,0,1.51,.4l49.47,51.82,36.14-19.33s-54-54-71.22-65.14c0,0-7.42-6.94-16.41-4.54l-88.11,17.58c-11.9,1.64-23.63,4.38-35.02,8.21Z",
    fill: "#bce1ca",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 134.81,
    y1: 563.77,
    x2: 150.83,
    y2: 563.77,
    fill: "none",
    stroke: "#ed1c24",
    strokeMiterlimit: 10
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "321.9 427.19 328.21 383.61 385.8 373.5 379.05 418.49 321.9 427.19",
    fill: "#fff",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "289.56 432.06 321.9 427.19 328.21 383.61 325.21 384.31 319.35 424.45 289.56 429.02 289.56 432.06",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 354.85,
    cy: 399.43,
    rx: 3.94,
    ry: 3.21,
    transform: "translate(-151.79 569.07) rotate(-66.89)",
    fill: "#4ade80",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.18,199.44v74.82c0,2.48,2.02,4.49,4.5,4.5h124.14c2.49,0,4.5-2.01,4.5-4.5v-74.82c0-2.49-2.01-4.5-4.5-4.5H69.68c-2.48,0-4.49,2.02-4.5,4.5Z",
    fill: "#bce1ca",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M466.98,255.81l5-3.15-4-6.17-4.62,3.25-4.11-6.63,4.93-3.01-3-5-5.31,2.94-19.58-30.17c5.25-5.57,7.84-13.14,7.09-20.76-1.13-12-12.38-23-24.43-23.89-14.62-1.09-27.36,9.88-28.45,24.5-.12,1.56-.1,3.13,.06,4.68,1.28,12.94,13.52,23.89,26.52,23.83,2.55,0,5.08-.38,7.52-1.12l36.31,55c.23,.35,.59,.6,1,.7l9.74,2.25c.12,.03,.24-.03,.27-.15,0-.02,0-.05,0-.07v-9.32c0-.34-.1-.66-.29-.94l-4.66-6.77Zm-52.68-66.49h0c-.75,.35-1.55,.59-2.37,.73-5.31,.91-10.36-2.66-11.27-7.97,0,0,0-.02,0-.03-.3-1.72-.13-3.48,.5-5.11,1.91-5.04,7.54-7.58,12.58-5.67,5.04,1.91,7.58,7.54,5.67,12.58-.92,2.42-2.75,4.37-5.1,5.43v.03Z",
    fill: "#4ade80",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 255.67,
    y: 265.6,
    width: 44,
    height: 65.5,
    rx: 21.75,
    ry: 21.75,
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 246.25,
    cy: 256.32,
    rx: 13.66,
    ry: 13.89,
    transform: "translate(-25.26 26.93) rotate(-5.95)",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.11,
    cy: 263.95,
    rx: 10.51,
    ry: 10.69,
    transform: "translate(-26 27.89) rotate(-5.95)",
    fill: "#4ade80",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.35,278.42c-2.68,2.67-8.59,6.92-20.25,9.07,0,0,1.36,7.48-7.19,15.08-2.48,2.21-4.15,5.24-4.54,8.58-.62,5.29-.19,11.96,10.81,17.96,0,0-8.94,4.03-17.5,2.09,0,0-4.63,5.81-13.24,6.27-3.54,.19-6.99-1.65-8.71-4.81-2.28-4.21-3.87-12.02-.12-26.07,0,0,7.43-48.93,34.98-51.8,0,0,12.49-3.33,23.93,1.42,11.53,4.79,15.33,25.27,12.01,34.26l-2.26-3.93c-1.83-3.19-2.18-3.81-3.34-7.01-.12-.32-.29-.62-.5-.88h0c-1.07-1.27-2.91-1.38-4.08-.22Z",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.86,
    cy: 301.67,
    rx: 4.9,
    ry: 6.67,
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 228.67,
    y1: 407.6,
    x2: 256.67,
    y2: 408.6,
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 253.17,
    y1: 424.1,
    x2: 258.91,
    y2: 421.37,
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M234.67,407.6l9.12-20.06c1.04-2.29,1.83-4.69,2.32-7.17,1.08-5.52,1.62-14.55-3.44-22.77",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M272.67,413.6s4.5-.5,8.48-5.16c0,0,4.02-6.34,8.41,2.52",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M295.89,411.04s-2.72-5.94-6.72-6.94",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M300.75,410.52s-1.58-3.42-6.58-6.42",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M310.17,402.1s.42-8.82-1.05-14.14c-.2-.73-.5-1.43-.83-2.11-1.31-2.68-5.46-12.1-4.62-22.25",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M428.11,590.59c-4.81,1.7-10.17,.24-13.45-3.66l-11.45-21.31c-1.5-3.75-.8-8.02,1.81-11.09h0l-1.72-7.98,11.33-3.76,1.6,4.2c1,6.16,2.94,12.13,5.75,17.69l.05,.1c3.36,6.86,7.38,13.38,12,19.46,3.1,4.65-5.92,6.34-5.92,6.34Z",
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M439.05,589.46c6,8.49-.33,9.86-.33,9.86l-8.66,2.52s0,0,0,0c-9.86,1.91-18.11-11.4-19.11-13.09-.03-.05-.09-.02-.09,.03l.41,7.28s-.02,.05-.05,.05l-3.26,.1s-.04-.01-.05-.04l-7.11-26.77s0,0,0,0c-4.45-12.47,2.2-14.59,3.78-14.92,.12-.02,.19,.11,.12,.21-4.86,6.33-1.19,12.31-1.19,12.31l10.65,18.56s0,0,0,0c4.45,6.01,9,6.52,13.8,4.82,0,0,9.14-1.3,6.07-6.01l5.01,5.08Z",
    fill: "#4ade80",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M425.39,547.26c-2,2-39,10.93-39,10.93l-27.26-73.6c-.1-.39-.32-.74-.62-1-1.54-1.26-2.68-2.95-3.27-4.85-.26-.84-1.03-1.42-1.91-1.42l-50.51,.78,68.55-29.66c.72-.28,1.53,.02,1.91,.69,0,0,.94,3.4,6.94,1.83,0,0,.7-.45,1.51,.4,0,0,8.2,10.28,21.35,41.7l22.31,54.2Z",
    fill: "#bce1ca",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M256.17,450.1s31-13,41.93,.45c13.31,18.68,24,39.09,31.79,60.66,0,0,21.3,48.15-25.59,65.1-5.24,1.89-10.79,2.8-16.36,2.76l-19.86-.16s45.21-11,40.79-50.6c0,0-7.72-40.92-23.94-71.14,0,.02-13.98-6.64-28.77-7.07Z",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M148.57,367.31l19.02-.83,26.59,99.49s18.32-4.71,30.43-9.05c0,0,50.56-16.82,59.3-1.56,0,0,16.38,27.64,25,73,0,0,6,43.92-40.79,50.6-2.18,.31-141.61,0-141.61,0l6.17-195.57c.27-8.69,7.2-15.7,15.89-16.08Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M167.6,366.48l11.9,1.44c3.38,.41,6.21,2.77,7.21,6.03l1.65,5.36,26.05,81-20.21,5.66-26.62-99.52",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 164.61,
    y: 241.43,
    width: 23.14,
    height: 20.41,
    fill: "#fff",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.17,
    y: 241.43,
    width: 23.14,
    height: 20.41,
    fill: "#fff",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.46,
    y: 241.43,
    width: 23.14,
    height: 20.41,
    fill: "#fff",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.75,
    y: 241.43,
    width: 23.14,
    height: 20.41,
    fill: "#fff",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(82.21 258.34)",
    fill: "#002346",
    fontFamily: "Barlow-SemiBold, Barlow",
    fontSize: 18.95,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(112.21 258.31)",
    fill: "#002346",
    fontFamily: "Barlow-SemiBold, Barlow",
    fontSize: 18.95,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(142.21 258.27)",
    fill: "#002346",
    fontFamily: "Barlow-SemiBold, Barlow",
    fontSize: 18.95,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(171.21 258.27)",
    fill: "#002346",
    fontFamily: "Barlow-SemiBold, Barlow",
    fontSize: 18.95,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(101.43 221.5)",
    fill: "#002346",
    fontFamily: "Barlow-Medium, Barlow",
    fontSize: 12,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-.05em"
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.58,
    y: 0,
    letterSpacing: "0em"
  }, "erific"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.3,
    y: 0,
    letterSpacing: "0em"
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.42,
    y: 0
  }, "tion")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(80.7 232.5)",
    fill: "#002346",
    fontFamily: "Barlow-Regular, Barlow",
    fontSize: 5
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pl"), /*#__PURE__*/React.createElement("tspan", {
    x: 4.11,
    y: 0,
    letterSpacing: "0em"
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.75,
    y: 0,
    letterSpacing: "0em"
  }, "ase en"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.73,
    y: 0,
    letterSpacing: "-.02em"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.48,
    y: 0
  }, "er t"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.78,
    y: 0,
    letterSpacing: "0em"
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.44,
    y: 0
  }, "e "), /*#__PURE__*/React.createElement("tspan", {
    x: 36.11,
    y: 0,
    letterSpacing: "0em"
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    x: 39.17,
    y: 0,
    letterSpacing: "0em"
  }, "TP "), /*#__PURE__*/React.createElement("tspan", {
    x: 45.98,
    y: 0,
    letterSpacing: "0em"
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.56,
    y: 0
  }, "ode se"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.75,
    y: 0,
    letterSpacing: "0em"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 65.41,
    y: 0
  }, "d "), /*#__PURE__*/React.createElement("tspan", {
    x: 69.14,
    y: 0,
    letterSpacing: "-.01em"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.89,
    y: 0
  }, "o "), /*#__PURE__*/React.createElement("tspan", {
    x: 74.61,
    y: 0,
    letterSpacing: "-.02em"
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 76.83,
    y: 0
  }, "our num"), /*#__PURE__*/React.createElement("tspan", {
    x: 94.56,
    y: 0,
    letterSpacing: "0em"
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    x: 97.26,
    y: 0
  }, "er")))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M163.67,284.6s-10,63,60,70",
    fill: "none",
    stroke: "#002346",
    strokeDasharray: "0 0 11 9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 524.3,
    y1: 159.49,
    x2: 554.64,
    y2: 159.49,
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 523.3,
    y1: 168.49,
    x2: 553.64,
    y2: 168.49,
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 522.3,
    y1: 177.49,
    x2: 552.64,
    y2: 177.49,
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "519.23 293.44 592.67 325.6 679.88 293.44",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M595.67,352.1c0-3.04-2.46-5.5-5.5-5.5s-5.5,2.46-5.5,5.5c0,2.33,1.45,4.32,3.5,5.12v6.88c0,1.1,.9,2,2,2s2-.9,2-2v-6.88c2.05-.8,3.5-2.79,3.5-5.12Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(565.98 251.43)",
    fill: "#002346",
    fontFamily: "Barlow-SemiBold, Barlow",
    fontSize: 33.48,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".08em"
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.13,
    y: 0,
    letterSpacing: ".06em"
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.08,
    y: 0,
    letterSpacing: ".08em"
  }, "60"))), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 683.67,
    y1: 102.6,
    x2: 593.67,
    y2: 121.6,
    fill: "none",
    stroke: "#002346",
    strokeDasharray: "0 0 11 9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M727.81,244.08s32.86,33.51,24.86,93.51",
    fill: "none",
    stroke: "#002346",
    strokeDasharray: "0 0 11 9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.72,522.71c.2,2.34,.51,4.98,.96,7.67,0,0,9.48-31.02,40.64-27.02l-6.12-13.48-5.06-5.06c-10.16,5.28-20,3.69-26.72,17.32-3.14,6.36-4.31,13.51-3.69,20.58Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.57,493.01c-28.12,.03-32.32-41.41-3.91-75.9,.09-.11,.27-.04,.26,.11-1.12,11.76,33.4,53.9,10.78,73.19-1.99,1.69-4.51,2.6-7.12,2.6Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.87,477.53c-17.74-10.53-13.74-42.1,38.83-60.73,.1-.03,.2,.06,.16,.15-.6,1.71-4.08,12.88-5.91,44.4-.49,8.4-12.49,28.4-33.08,16.17Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.23,546.72c.8,6.21-41.3,6.21-40.5,0-.8-6.21,41.3-6.21,40.5,0Z",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.89,601.72c-1.82-.27-48.18,.79-48.29-.86-9.13-4.33-9.52-18.47-9.52-18.47-1.38-18.87,15.65-28.99,15.65-28.99v-6.67c-.8,6.21,41.3,6.21,40.5,0v7.13c22.29,14.63,17.77,46.38,1.66,47.86Z",
    fill: "#4ade80",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.61,562.14c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.9,570.42c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.28,583.77c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.91,593.89c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.36,596.65c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.87,593.89c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.21,586.07c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.59,570.42c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.71,561.22c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.92,569.5c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.33,576.86c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.54,586.07c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.66,578.25c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.5,562.6c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.79,572.26c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.23,578.71c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.03,587.91c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.08,515.65c-15.18-12.36-36.76,4.61-15.19,25.77,0,0,11.05,10.12,15.65,20.71,0,0,21.17-15.19,21.63-35.9,0,0,0-21.17-22.09-10.59Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.24,513.09c23.85-42.04,34.03,1.19,69.93-4.8,.54-48.33-69.4-46.3-69.93,4.8Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.73,553.39s16.99,8.72,40.5,.46",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.24,531.09s10-42,35.45-21.63c3.58,2.86,5.82,7.08,6.91,11.53,1.69,6.9,3.83,19.46,1.14,31.6",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.74,420.59s-47,34-31,126",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.74,485.59s62-1,64,60",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpImage);
export default __webpack_public_path__ + "static/media/otp-image.8561ff53863827c4f0150ec44cc76484.svg";
export { ForwardRef as ReactComponent };